import { useTranslation } from "react-i18next";

function PropertiesEmpty() {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <div className="text-gray-400 mb-2">
        <svg
          className="mx-auto h-12 w-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
          />
        </svg>
      </div>
      <h3 className="text-sm font-medium text-gray-700 mb-1">
        {t("properties_empty_title")}
      </h3>
      <p className="text-xs text-gray-500">
        {t("properties_empty_body")}
      </p>
    </div>
  );
}

export default PropertiesEmpty;
